const langLabels = {
  loginLog: {
    username: '用户名',
    nickName: '昵称',
    state: '状态',
    loginIp: '登录IP',
    createTime: '登录时间',
    usernamePlaceholder: '请输入用户名',
    nickNamePlaceholder: '请输入用户昵称',
    loginState: '登录状态'
  },
  logError: {
    module: '模块',
    method: '操作方式',
    requestUri: '请求URI',
    remoteIp: '操作IP地址',
    message: '异常信息',
    stackTrace: '堆栈',
    params: '操作提交的数据',
    createName: '创建者',
    createTime: '创建时间',
    dialogTitle: '异常详情',
    modulePlaceholder: '请输入异常模块',
    requestUriPlaceholder: '请输入请求URI'
  },
  logOper: {
    title: '日志标题',
    type: '日志类型',
    module: '模块',
    method: '操作方式',
    requestUri: '请求URI',
    remoteIp: '操作IP地址',
    params: '操作提交的数据',
    createName: '创建者',
    createTime: '创建时间',
    titlePlaceholder: '请输入日志标题',
    modulePlaceholder: '请输入模块',
    typePlaceholder: '请输入日志类型',
    createNamePlaceholder: '请输入创建者'
  }
}
export default langLabels
